import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { loadVime } from './vime-loader';
import * as i0 from "@angular/core";
/** Base class for developing custom vime components/plugins */
export let CustomVimeComponent = /*#__PURE__*/(() => {
  class CustomVimeComponent {
    constructor(c, ref, z) {
      this.c = c;
      this.ref = ref;
      this.z = z;
      this.unbindPlayerContext = () => {};
      this.playerCache = new Map();
      this.assignProps();
      // this.bindContext().then(handler=>this.unbindPlayerContext = handler);
      // this.unbindPlayerContext = await 
    }
    ngOnInit() {
      var _this = this;
      return _asyncToGenerator(function* () {
        return loadVime().then(assets => {
          _this.vime = assets;
        });
      })();
    }
    // extended version of vimes VimeComponent: support mapping observables (created observables will have a trailing $)
    // override this and call super.assignProps([... props to map])
    assignProps(magicProps = [], observableProps = []) {
      const propDefinitions = {};
      const pc = this.playerCache;
      magicProps.forEach(prop => {
        pc.set(prop, this[prop]);
        propDefinitions[prop] = {
          get() {
            return pc.get(prop);
          },
          set: value => {
            if (pc.get(prop) !== value) {
              this.dispatch(prop, value);
              pc.set(prop, value);
            }
          }
        };
      });
      if (observableProps) {
        observableProps.forEach(prop => {
          const subj = new BehaviorSubject(void 0);
          pc.set(prop + '$', subj);
          propDefinitions[prop + '$'] = {
            get() {
              // console.log('>>>',prop,pc,pc.get(prop))
              return subj.asObservable();
            }
          };
        });
      }
      let allProps = [...magicProps, ...observableProps];
      allProps = [...new Set(allProps)]; // remove duplicates
      this.playerProps = allProps;
      Object.defineProperties(this, propDefinitions);
    }
    ngAfterViewInit() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        // if (!this.ref.nativeElement) return;
        // it seems that without a small timeout, this will lead to the findPlayer event being thrown before player is ready and listening.
        // at least when the page is in background and throttled. Setting the timeout seems to allow the player to get ready for events & context binding.
        setTimeout(/*#__PURE__*/_asyncToGenerator(function* () {
          _this2.dispatch = _this2.vime.createDispatcher(_this2.ref.nativeElement);
          _this2.unbindPlayerContext = yield _this2.bindContext();
        }), 100);
      })();
    }
    getPlayer() {
      var _this3 = this;
      return _asyncToGenerator(function* () {
        if (_this3.player) return _this3.player;
        try {
          _this3.player = yield _this3.vime.findPlayer(_this3.ref.nativeElement);
          return _this3.player;
        } catch (err) {
          console.log('Failed to find parent Player by event, fall back to traversing Dom');
          let el = _this3.ref.nativeElement;
          while (el.parentElement && !(el instanceof _this3.vime.VmPlayer)) {
            el = el.parentElement;
          }
          if (el instanceof _this3.vime.VmPlayer) {
            _this3.player = el;
            return _this3.player;
          } else {
            throw new Error('findPlayer has failed, as well as fallback method traversing the DOM to find the parent player.');
          }
        }
      })();
    }
    bindContext() {
      var _this4 = this;
      return _asyncToGenerator(function* () {
        const player = yield _this4.getPlayer();
        const handler = yield _this4.vime.usePlayerContext(_this4.ref.nativeElement, _this4.playerProps, _this4.updateContext.bind(_this4), player);
        // BUG: For some reason, it seems that the created context will not populate props initially.
        // only when a prop is updated AFTER context creation, it will be available. 
        // fix by syncing the initial data manually here.
        _this4.playerProps.forEach(p => _this4.updateContext(p, player[p]));
        return handler;
      })();
    }
    updateContext(prop, value) {
      if (this.playerCache.has(prop + '$')) {
        this.playerCache.get(prop + '$').next(value);
      }
      if (this.playerCache.has(prop)) {
        this.playerCache.set(prop, value);
        this[prop] = value;
      }
    }
    ngOnDestroy() {
      this.unbindPlayerContext?.();
      this.playerCache.clear();
    }
    static {
      this.ɵfac = function CustomVimeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomVimeComponent)(i0.ɵɵinject(i0.ChangeDetectorRef), i0.ɵɵinject(i0.ElementRef), i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CustomVimeComponent,
        factory: CustomVimeComponent.ɵfac
      });
    }
  }
  return CustomVimeComponent;
})();